var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(this.$t(this.graphTitle, { start_year: this.linearWindowsYears[0].toString(), end_year: this.linearWindowsYears[this.linearWindowsYears.length - 1].toString() })))]),_c('line-graph',{attrs:{"chart-data":_vm.linearChartData,"chart-options":_vm.linearChartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }